import { MatSnackBar } from '@angular/material/snack-bar';

export function provideSnackbar() {
  return [MatSnackBar];
}
